<template>
  <base-link
    class="flex items-center gap-1 duration hover:bg-grey-90 "
    :class="[brandClasses.title, presets?.[content.menuStyle!], { [brandClasses.featured!]: l2?.featured }]"
    :target="content.target?.targetAttribute"
    :to="content.target?.url"
    @click.stop="$emit('click')"
  >
    <vf-icon v-if="content.menuIcon" :name="content.menuIcon.icon" size="xs" />
    <span v-if="$feature.showTitleHtml" v-html="content.titleHtml" />
    <span v-else>{{ content.title }}</span>
  </base-link>
</template>

<script lang="ts" setup>
import type { MenuItem } from '#types/components/cms/mega-menu'
import { MegaMenuL2ContextKey } from '#content/contexts/megamenu'

defineProps<{
  content: MenuItem
}>()

defineEmits<{
  click: []
}>()

const { brandClasses, presets } = useAppConfig().components.cms.megaMenuL3Mobile

const l2 = inject(MegaMenuL2ContextKey)
</script>
